import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=80370c8a"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports